import React from "react";
import { Lock } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { INDUSTRIES } from "../constants";

interface AddBrandStepIndustryProps {
  isDetailsFetched: boolean;
  industry: string;
  onIndustryChange: (value: string) => void;
}

export const AddBrandStepIndustry: React.FC<AddBrandStepIndustryProps> = ({
  isDetailsFetched,
  industry,
  onIndustryChange,
}) => {
  return (
    <div className="relative flex items-start gap-4">
      {/* Step Circle */}
      <div
        className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold shrink-0 z-10 transition-all duration-500 delay-250 ${
          isDetailsFetched
            ? "bg-[#A655F8] text-white shadow-sm scale-100"
            : "bg-slate-100 text-slate-400 scale-95"
        }`}
      >
        3
      </div>

      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-semibold text-slate-900">Select Industry</h3>
        <p className="text-xs text-slate-500 mt-0.5">
          Choose the industry that best fits this brand.
        </p>

        <div className="mt-3">
          {!isDetailsFetched ? (
            /* Locked state */
            <div className="rounded-xl border border-slate-100 bg-slate-50/60 p-4 flex items-center gap-3.5 transition-all duration-300">
              <div className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">
                <Lock className="w-4 h-4 text-slate-400" />
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-700">
                  Available after brand details are fetched.
                </p>
                <p className="text-[11px] text-slate-400 mt-0.5">
                  We&apos;ll enable this once we have the brand information.
                </p>
              </div>
            </div>
          ) : (
            /* Dropdown select with entrance animation */
            <div className="animate-in fade-in-0 slide-in-from-top-3 duration-500 delay-200 ease-out fill-mode-both">
              <Select value={industry} onValueChange={onIndustryChange}>
                <SelectTrigger className="w-full h-11 rounded-xl bg-white border-slate-200 text-sm text-slate-800 focus:ring-0 focus:ring-offset-0 focus:border-[#A655F8] focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-[#A655F8] transition-colors">
                  <SelectValue placeholder="Select industry" />
                </SelectTrigger>
                <SelectContent className="max-h-60 rounded-xl">
                  {INDUSTRIES.map((ind) => (
                    <SelectItem key={ind} value={ind} className="rounded-lg">
                      {ind}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
